<template>
  <div class="login-page">
    <div class="login-container">
      <div class="platform-name">合作商管理后台</div>
      <el-card class="login-card" shadow="never">
        <div class="login-title">登录</div>

        <!-- 登录方式切换 Tab -->
        <div class="login-tabs">
          <div
            class="tab-item"
            :class="{ active: loginType === 'account' }"
            @click="switchTab('account')"
          >
            账号密码登录
          </div>
          <div
            class="tab-item"
            :class="{ active: loginType === 'phone' }"
            @click="switchTab('phone')"
          >
            手机号登录
          </div>
        </div>

        <!-- ========== 账号密码登录 ========== -->
        <el-form
          v-if="loginType === 'account'"
          :model="accountForm"
          :rules="accountRules"
          ref="accountFormRef"
          label-position="left"
          label-width="0"
        >
          <el-form-item prop="phone">
            <el-input
              v-model="accountForm.phone"
              placeholder="手机号"
              size="large"
              prefix-icon="el-icon-user"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              type="password"
              v-model="accountForm.password"
              placeholder="密码"
              size="large"
              prefix-icon="el-icon-lock"
            ></el-input>
          </el-form-item>
          <el-form-item prop="vailCode">
            <el-row :gutter="12">
              <el-col :span="16">
                <el-input
                  v-model="accountForm.vailCode"
                  placeholder="图片验证码"
                  size="large"
                  prefix-icon="el-icon-key"
                ></el-input>
              </el-col>
              <el-col :span="8">
                <img
                  :src="captchaUrl"
                  class="captcha-img"
                  @click="refreshCaptcha"
                  alt="验证码"
                />
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="handleAccountLogin"
              :loading="loading"
              style="width: 100%"
              size="large"
              >登录</el-button
            >
          </el-form-item>
        </el-form>

        <!-- ========== 手机号登录 ========== -->
        <el-form
          v-if="loginType === 'phone'"
          :model="phoneForm"
          :rules="phoneRules"
          ref="phoneFormRef"
          label-position="left"
          label-width="0"
        >
          <el-form-item prop="phone">
            <el-input
              v-model="phoneForm.phone"
              placeholder="手机号"
              size="large"
              prefix-icon="el-icon-phone"
            ></el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-row :gutter="12">
              <el-col :span="16">
                <el-input
                  v-model="phoneForm.code"
                  placeholder="短信验证码"
                  size="large"
                  prefix-icon="el-icon-key"
                ></el-input>
              </el-col>
              <el-col :span="8">
                <el-button
                  class="sms-btn"
                  :disabled="smsDisabled || !isPhoneValid"
                  @click="handleSendSms"
                  size="large"
                  plain
                >
                  {{ smsBtnText }}
                </el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="handlePhoneLogin"
              :loading="loading"
              style="width: 100%"
              size="large"
              >登录</el-button
            >
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
// ============================================================
// 请根据实际后端接口路径调整以下 API 导入
// ============================================================
import {
  LoginChannel,
  SendSmsCode,
  QueryLoginVerifyCode,
  PhoneLogin,
} from "../api/login";

export default {
  name: "Login",
  data() {
    // 手机号格式校验
    const validatePhone = (rule, value, callback) => {
      const reg = /^1[3-9]\d{9}$/;
      if (!value) {
        callback(new Error("请输入手机号"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    return {
      // ---------- 登录方式 ----------
      loginType: "account", // 'account' | 'phone'

      // ---------- 加载状态 ----------
      loading: false,

      // ---------- 账号密码登录表单 ----------
      accountForm: {
        phone: "",
        password: "",
        vailCode: "",
      },
      accountRules: {
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        vailCode: [
          { required: true, message: "请输入图片验证码", trigger: "blur" },
        ],
      },

      // ---------- 手机号登录表单 ----------
      phoneForm: {
        phone: "",
        code: "",
      },
      phoneRules: {
        phone: [{ required: true, validator: validatePhone, trigger: "blur" }],
        code: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
          { len: 4, message: "验证码为4位数字", trigger: "blur" },
        ],
      },

      // ---------- 图片验证码 ----------
      captchaUrl: "/api/captcha?t=" + Date.now(),

      // ---------- 短信验证码 ----------
      smsCountdown: 0, // 倒计时秒数
      smsTimer: null, // 定时器句柄
    };
  },
  computed: {
    // 短信验证码按钮是否禁用
    smsDisabled() {
      return this.smsCountdown > 0;
    },
    // 短信验证码按钮文字
    smsBtnText() {
      return this.smsCountdown > 0 ? `${this.smsCountdown}s` : "获取验证码";
    },
    // 手机号是否有效（用于控制获取验证码按钮）
    isPhoneValid() {
      const reg = /^1[3-9]\d{9}$/;
      return reg.test(this.phoneForm.phone);
    },
  },
  mounted() {
    // 初始化时刷新图片验证码
    this.refreshCaptcha();
  },
  beforeDestroy() {
    // 组件销毁时清除定时器
    if (this.smsTimer) {
      clearInterval(this.smsTimer);
      this.smsTimer = null;
    }
  },
  methods: {
    // ============================================================
    // 切换登录方式
    // ============================================================
    switchTab(type) {
      if (this.loginType === type) return;
      this.loginType = type;
      // 切换时重置表单
      if (type === "account") {
        this.$refs.accountFormRef?.resetFields();
        this.accountForm.captcha = "";
        this.refreshCaptcha();
      } else {
        this.$refs.phoneFormRef?.resetFields();
        this.phoneForm.code = "";
        // 清除倒计时
        if (this.smsTimer) {
          clearInterval(this.smsTimer);
          this.smsTimer = null;
        }
        this.smsCountdown = 0;
      }
    },

    // ============================================================
    // 图片验证码刷新
    // ============================================================
    refreshCaptcha() {
      this.captchaUrl =
        systemConfig.serverUrl + "/Login/QueryLoginVerifyCode?t=" + Date.now();
    },

    // ============================================================
    // 发送短信验证码
    // ============================================================
    handleSendSms() {
      this.$refs.phoneFormRef.validateField("phone", (errorMsg) => {
        if (errorMsg) {
          // 校验未通过，提示已由表单自动显示
          return;
        }
        // 调用发送验证码接口（请确认接口函数名）
        SendSmsCode({ mobile: this.phoneForm.phone }) // 或您实际的发送接口
          .then((res) => {
            if (res.data.isSuccess) {
              this.$message.success(res.data.message || "验证码已发送");
              this.startCountdown();
            } else {
              this.$message.error(res.data.message || "发送失败");
            }
          })
          .catch(() => {
            this.$message.error("发送失败，请检查网络");
          });
      });
    },

    // 开始倒计时
    startCountdown() {
      if (this.smsTimer) {
        clearInterval(this.smsTimer);
        this.smsTimer = null;
      }
      this.smsCountdown = 60;
      this.smsTimer = setInterval(() => {
        this.smsCountdown--;
        if (this.smsCountdown <= 0) {
          clearInterval(this.smsTimer);
          this.smsTimer = null;
        }
      }, 1000);
    },

    // ============================================================
    // 账号密码登录
    // ============================================================
    handleAccountLogin() {
      this.$refs.accountFormRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;

        // TODO: 调用登录接口，需携带验证码
        LoginChannel(this.accountForm)
          .then((res) => {
            if (res.data.isSuccess) {
              const data = res.data.data || {};
              const token = data.userToken || "";
              if (!token) {
                this.$message.error("登录失败：未获取到登录凭证");
                return;
              }

              sessionStorage.setItem("userInfo", JSON.stringify(data.user));
              sessionStorage.setItem("access_token", token);

              //权限设置
              let permissions = [
                "code-manage",
                // "code-manage-index",
                "order-manage-list",
                "order-manage-settlement",
                "role-list",
                "system-user",
                // "orderManageListSummary",
              ];
              //data.menuIds
              sessionStorage.getItem("access_token");
              sessionStorage.getItem("permissions");
              sessionStorage.setItem(
                "permissions",
                JSON.stringify(data.menuIds || []),
              );

              this.$message.success(res.data.message);
              this.$router.push({ path: "/home/dashboard" }).catch((err) => {
                if (err && err.name !== "NavigationDuplicated") {
                  console.error(err);
                }
              });
            } else {
              this.$message.error(res.data.message);
              // 登录失败刷新验证码
              this.refreshCaptcha();
              this.accountForm.captcha = "";
            }
          })
          .catch(() => {
            this.$message.error("登录失败，请检查网络");
            this.refreshCaptcha();
            this.accountForm.captcha = "";
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    // ============================================================
    // 手机号登录
    // ============================================================
    handlePhoneLogin() {
      this.$refs.phoneFormRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;

        // TODO: 调用手机号登录接口
        // 假设接口为 loginByPhone，参数 { phone, smsCode }
        console.log("[手机号登录]", this.phoneForm);

        // 模拟登录成功（实际请替换为真实接口）
        // 真实调用示例（取消注释并按实际接口调整）：
        PhoneLogin(this.phoneForm)
          .then((res) => {
            if (res.data.isSuccess) {
              const data = res.data.data || {};
              const token = data.userToken || "";
              if (!token) {
                this.$message.error("登录失败：未获取到登录凭证");
                return;
              }
              sessionStorage.setItem("userInfo", JSON.stringify(data.user));
              sessionStorage.setItem("access_token", token);
              this.$message.success(res.data.message);
              this.$router.push({ path: "/home/dashboard" }).catch((err) => {
                if (err && err.name !== "NavigationDuplicated") {
                  console.error(err);
                }
              });
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch(() => {
            this.$message.error("登录失败，请检查网络");
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
  },
};
</script>

<style scoped>
/* ========== 页面整体 ========== */
.login-page {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f7fa;
  background-size: cover;
  background-position: center;
}

.login-container {
  text-align: center;
}

.platform-name {
  font-size: 28px;
  font-weight: bold;
  color: #409eff;
  margin-bottom: 20px;
}

.login-card {
  width: 420px;
  padding: 30px 35px 40px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #e4e7ed;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.login-title {
  font-size: 24px;
  margin-bottom: 20px;
  color: #303133;
  font-weight: 500;
  text-align: center;
}

/* ========== Tab 切换 ========== */
.login-tabs {
  display: flex;
  border-bottom: 1px solid #e4e7ed;
  margin-bottom: 24px;
}

.tab-item {
  flex: 1;
  text-align: center;
  padding: 12px 0 10px;
  font-size: 15px;
  color: #909399;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.25s;
  user-select: none;
}

.tab-item:hover {
  color: #409eff;
}

.tab-item.active {
  color: #409eff;
  border-bottom-color: #409eff;
  font-weight: 500;
}

/* ========== 表单 ========== */
.el-form-item {
  margin-bottom: 20px;
}

.el-input--large .el-input__inner {
  height: 44px;
  line-height: 44px;
}

/* ========== 图片验证码 ========== */
.captcha-img {
  width: 100%;
  height: 39px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  cursor: pointer;
  display: block;
  background: #fafafa;
  object-fit: contain;
  transition: border-color 0.2s;
}

.captcha-img:hover {
  border-color: #409eff;
}

/* ========== 短信验证码按钮 ========== */
.sms-btn {
  width: 100%;
  height: 39px;
  padding: 0;
  font-size: 14px;
  border-radius: 4px;
  background-color: #ecf5ff;
  border-color: #b3d8ff;
  color: #409eff;
}

.sms-btn:hover:not(.is-disabled) {
  background-color: #d9ecff;
  border-color: #79bbff;
}

.sms-btn.is-disabled {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
}

/* ========== 登录按钮 ========== */
.el-button--primary.el-button--large {
  height: 44px;
  font-size: 16px;
  letter-spacing: 4px;
}

/* ========== 响应式微调 ========== */
@media screen and (max-width: 480px) {
  .login-card {
    width: 92%;
    padding: 20px 18px 30px;
  }

  .platform-name {
    font-size: 22px;
  }

  .login-title {
    font-size: 20px;
  }
}
</style>
